<template>
    <el-dialog
            :title="'修改密码'"
            :close-on-click-modal="false"
            :visible.sync="visible"
            style="text-align: left">
            <el-form :model="dataForm" status-icon :rules="rules" ref="dataForm" label-width="100px">
                <el-form-item label="原密码" prop="oldPassword">
                    <el-input type="password" v-model="dataForm.oldPassword" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="新密码" prop="password">
                    <el-input type="password" v-model="dataForm.password" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="确认密码" prop="password1">
                    <el-input type="password" v-model="dataForm.password1" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
        <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
    </el-dialog>
</template>

<script>
    export default {

        data () {
            const validateNumber = (rule, value, callback) => {
                var patrn = /^\d+(\.\d+)?$/;
                if (!patrn.exec(value)) {
                    callback(new Error('请填写数字'))
                } else {
                    callback()
                }
            }
            return {
                //表单验证规则
                rules: {
                    password: [
                        { validator: this.validatePass, trigger: 'blur' },
                        {
                            min: 8,
                            max: 18,
                            message: "密码长度必须为 8 到 18 个字符",
                            trigger: "blur",
                        },
                        {
                            pattern:
                                /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^\w\s]).{8,18}$/,
                            message:
                                "密码必须由数字、大小写字母、特殊字符组成,每项都至少包含一个",
                            trigger: "blur",
                        }
                    ],
                    password1: [
                        { validator: this.validatePass2, trigger: 'blur' },
                        {
                            min: 8,
                            max: 18,
                            message: "密码长度必须为 8 到 18 个字符",
                            trigger: "blur",
                        },
                        {
                            pattern:
                                /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^\w\s]).{8,18}$/,
                            message:
                                "密码必须由数字、大小写字母、特殊字符组成,每项都至少包含一个",
                            trigger: "blur",
                        }
                    ],
                    oldPassword: [
                        { validator: this.checkAge, trigger: 'blur' }
                    ]
                },
                visible: false,
                dataForm: {
                    oldPassword: '',
                    password: '',
                    password1: ''
                },

            }
        },
        methods: {
            init (id) {
                this.visible = true
                this.$nextTick
                (() => {
                    this.$refs['dataForm'].resetFields()
                })

            },
            // 表单提交
            // 表单提交
            dataFormSubmit () {
                this.$refs['dataForm'].validate((valid) => {
                    if (valid) {
                        this.$http({
                            url: `/user/password`,
                            method: 'post',
                            params: this.dataForm
                        }).then(data => {
                            // console.log("修改密码返回数据：",data)
                            if (data.status === 200 && data.data.code !== '1') {
                                this.$message({
                                    message: '修改成功',
                                    type: 'success',
                                    duration: 1500
                                })
                                this.visible = false
                                this.$emit('refreshDataList')
                            } else if(data.status === 200 && data.data.code === '1') {
                                this.$message({
                                    message: data.data.error,
                                    type: 'error',
                                    duration: 1500
                                })
                            } else {
                                this.$message({
                                    message: "修改失败",
                                    type: 'error',
                                    duration: 1500
                                })
                            }
                        }).catch(error => {
                            console.log(error)
                            this.$message({
                                message: "修改失败",
                                type: 'error',
                                duration: 1500
                            })
                        })
                    }
                })
            },
            validatePass(rule, value, callback){
                if (value === '') {
                    callback(new Error('请输入新密码'));
                } else {
                    if (this.dataForm.password1 !== '') {
                        this.$refs.dataForm.validateField('password1');
                    }
                    callback();
                }
            },
            validatePass2(rule, value, callback){
                if (value==='') {
                    callback(new Error('请再次输入新密码'));
                } else if (value !== this.dataForm.password) {
                    callback(new Error('两次输入密码不一致!'));
                } else {
                    callback();
                }
            },
            checkAge(rule, value, callback){
                if (!value) {
                    return callback(new Error('原密码不能为空'));
                } else {
                    callback();
                }
            }
        }
    }
</script>
